import { ReactNode } from "react";
import classNames from "classnames";
import { noop } from "@common/helpers/function";
import { TriangleIcon } from "@icons";
import { useAggregatedFiltersContext } from "@components/pageHeader/filters/AggregatedFilters/AggregatedFilters.context";
import { ActiveFilterButton } from "@components/pageHeader/filters/ActiveFilters/ActiveFilterButton";
import { formatFilterLabelText } from "@components/pageHeader/filters/ActiveFilters/formatFilterLabel";
import { FilterNavTab } from "@components/pageHeader/filters/FilterNavTab";
import { FilterTabPanel } from "@components/pageHeader/filters/FilterTabPanel";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import overlayStyles from "@components/pageHeader/filters/FiltersOverlay.module.scss";
import statusStyles from "@components/pageHeader/filters/Tabs/TransactionStatusFilter/TransactionStatusFilter.module.scss";
import { IntercompanyFilterTab } from "./intercompanyTransactionsFilters.lib";

export const IntercompanyFilterNavTab = ({
    tabKey,
    label,
    icon,
}: Readonly<{
    tabKey: IntercompanyFilterTab;
    label: string;
    icon: ReactNode;
}>) => (
    <FilterNavTab eventKey={tabKey} className={overlayStyles.navigationButton}>
        <span className={overlayStyles.navigationItem}>
            <span className={overlayStyles.navigationIcon}>{icon}</span>
            {label}
            <TriangleIcon
                className={classNames(
                    overlayStyles.navigationActiveIndicator,
                    "icon-color-gray-500",
                )}
            />
        </span>
    </FilterNavTab>
);

export const IntercompanyFilterPanel = ({
    tabKey,
    name,
    options,
    value,
    onChange,
    isSearchable,
}: Readonly<{
    tabKey: IntercompanyFilterTab;
    name: string;
    options: FilterMultiselectOption[];
    value: FilterMultiselectValue[];
    onChange: (values: FilterMultiselectValue[]) => void;
    isSearchable?: boolean;
}>) => (
    <FilterTabPanel eventKey={tabKey}>
        <div className={statusStyles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={isSearchable === true}
                options={options}
                value={value}
                onChange={onChange}
                name={name}
                onBlur={noop}
            />
        </div>
    </FilterTabPanel>
);

export const IntercompanyActiveFilterChip = ({
    tabKey,
    labels,
    pluralNoun,
    onReset,
}: Readonly<{
    tabKey: IntercompanyFilterTab;
    labels: string[];
    pluralNoun: string;
    onReset: () => void;
}>) => {
    const { open } = useAggregatedFiltersContext();
    const text = formatFilterLabelText(labels, pluralNoun);

    if (text === null) {
        return null;
    }

    return (
        <ActiveFilterButton
            openFilter={() => open(tabKey)}
            resetFilter={onReset}
            label={text}
        />
    );
};
